
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"1em","height":"1em","fill":"currentColor","viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M13 16.353c0-.247.181-.455.422-.508a6.52 6.52 0 005.08-6.827l-.37-5.16A2 2 0 0016.139 2H7.862a2 2 0 00-1.995 1.857L5.5 9.018a6.52 6.52 0 005.08 6.828c.24.053.421.261.421.508v2.3a1 1 0 01-.835.986l-1.33.222a1 1 0 00-.835.986V21a1 1 0 001 1h6a1 1 0 001-1v-.153a1 1 0 00-.835-.986l-1.33-.222a1 1 0 01-.835-.986v-2.3zM16.138 4H7.862l-.214 3h8.704l-.214-3z"}})])
          )
        }
      }
    